import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'

export type PublishCampaignFailureModalProps = Readonly<{
  isOpen: boolean
  handleClose: () => void
  errorCode: string
}>

const errorCodesMap = {
  'giving_campaigns/wrong_state': 'errorMessage.manageGivingCampaigns.wrongState'
} as const

export function PublishCampaignFailureModal({ isOpen, errorCode, handleClose }: PublishCampaignFailureModalProps) {
  const { t } = useTranslation()

  return (
    <Modal open={isOpen} onClose={handleClose} aria-labelledby="publish-campaign-failure">
      <AcknowledgeModal
        result="negative"
        title={t('typography.givingCampaigns.publishCampaign.failure.title')}
        description={t(errorCodesMap[errorCode] ?? 'errorMessage.genericError')}
        buttonText={t('button.close')}
        handleClose={handleClose}
      />
    </Modal>
  )
}
